import { VerificationNames, VerificationStatus } from "shared/types";
import { has } from "shared/utils";
import { formatToCurrency } from "utils/currency";
import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";
import { Cell } from "views/applications-id/components/ApplicantsTable/components/Cell";
import { ReportStatusBadge } from "views/applications-id/components/ApplicantsTable/components/ReportStatusBadge";
import {
  FullApplicant,
  Verification
} from "views/applications-id/components/ApplicantsTable/types";
export const IncomeReportSection = ({
  applicant,
  verification,
  hasAuditFlagEnabled
}: {
  applicant: FullApplicant;
  hasAuditFlagEnabled: boolean;
  verification: Verification[];
}) => {
  const verificationMap = verification.reduce(
    (acc, el) => {
      acc[el.name] = el;
      return acc;
    },
    {} as Record<string, Verification>
  );

  const selfReportedVerification = verificationMap[
    VerificationNames.IncomeVerification
  ] as Verification | undefined;
  const verifiedIncomeVerification =
    verificationMap[VerificationNames.VerifiedIncomeVerification];

  const statusSet = new Set(verification.map((el) => el.status));

  const isFailed = statusSet.has(VerificationStatus.Failed);
  const isFinishedWithWarnings = statusSet.has(
    VerificationStatus.FinishedWithWarnings
  );
  const isInProgress = statusSet.has(VerificationStatus.Started);
  const isPending = statusSet.has(VerificationStatus.Pending);

  const selfReportFinishedVerifiedIncomeInProgress =
    selfReportedVerification &&
    selfReportedVerification.status === VerificationStatus.Finished &&
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    verifiedIncomeVerification &&
    [VerificationStatus.Started, VerificationStatus.Submitted].includes(
      verifiedIncomeVerification.status
    );

  const mergedStatus = isFailed
    ? VerificationStatus.Failed
    : isFinishedWithWarnings
      ? VerificationStatus.FinishedWithWarnings
      : isInProgress || selfReportFinishedVerifiedIncomeInProgress
        ? VerificationStatus.Started
        : isPending
          ? VerificationStatus.Pending
          : VerificationStatus.Finished;

  return (
    <>
      {/* Empty cell for all rows */}
      <Cell className="bg-background-900" />
      <Cell isDataCell className="relative">
        {has(verification[0].summary?.gross_monthly_income) ? (
          formatToCurrency(verification[0].summary.gross_monthly_income)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
        <ReportStatusBadge verificationStatus={mergedStatus} />
      </Cell>
      <Cell isDataCell>
        {has(verification[0].summary?.net_monthly_income) ? (
          formatToCurrency(verification[0].summary.net_monthly_income)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
      <Cell isDataCell>
        {has(verification[1]?.summary?.gross_monthly_income) ? (
          formatToCurrency(verification[1].summary.gross_monthly_income)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
    </>
  );
};
